import React, { useEffect, useState } from 'react';
import { IoIosPeople } from "react-icons/io";
import { LiaBlogSolid } from "react-icons/lia";
import { PiArticleNyTimesFill } from "react-icons/pi";

const StatisticsCard = () => {
    const [buildingCount, setBuildingCount] = useState(0);
    const [landCount, setLandCount] = useState(0);
    const [customerCount, setCustomerCount] = useState(0);

    const targetCounts = {
        blogs: 200,
        articles: 340,
        customers: 590
    };

    useEffect(() => {
        const countToTarget = (currentCount, targetCount, setter) => {
            const increment = Math.ceil(targetCount / 100);
            if (currentCount < targetCount) {
                const timeout = setTimeout(() => {
                    setter(prevCount => Math.min(prevCount + increment, targetCount));
                }, 150);
                return () => clearTimeout(timeout);
            }
        };

        countToTarget(buildingCount, targetCounts.blogs, setBuildingCount);
        countToTarget(landCount, targetCounts.articles, setLandCount);
        countToTarget(customerCount, targetCounts.customers, setCustomerCount);
    }, [buildingCount, landCount, customerCount, targetCounts]);

    return (
        <div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="bg-[#e8e8fc] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] rounded-lg p-6 ">
                    <div className='flex items-center justify-between'>
                        <div className='border-2 border-[#bb0] text-[#bb0] rounded-full p-4'>
                            <LiaBlogSolid size={30} />
                        </div>
                        <div className='text-right flex flex-col gap-4'>
                            <h2 className="text-xl font-semibold text-gray-700">
                                Total Services
                            </h2>
                            <p className="text-xl font-extrabold text-[#bb0]">
                                {buildingCount} +
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-[#e8e8fc] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] rounded-lg p-6 ">
                    <div className='flex items-center justify-between'>
                        <div className='border-2 border-[#cd392c] text-[#cd392c] rounded-full p-4'>
                            <PiArticleNyTimesFill size={30} />
                        </div>
                        <div className='text-right flex flex-col gap-4'>
                            <h2 className="text-xl font-semibold text-gray-700">
                                Total Articles
                            </h2>
                            <p className="text-xl font-extrabold text-[#cd392c]">
                                {landCount} +
                            </p>
                        </div>
                    </div>
                </div>

                <div className="bg-[#e8e8fc] shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] rounded-lg p-6 ">
                    <div className='flex items-center justify-between'>
                        <div className='border-2 border-[#0159d1] text-[#0159d1] rounded-full p-4'>
                            <IoIosPeople size={30} />
                        </div>
                        <div className='text-right flex flex-col gap-4'>
                            <h2 className="text-xl font-semibold text-gray-700">
                                Total Customers
                            </h2>
                            <p className="text-xl font-extrabold text-[#0159d1]">
                                {customerCount} +
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StatisticsCard;
